<script setup lang="js">
import DeleteModal from '@/components/modals/DeleteModal.vue';
import RoleCreateModal from '@/components/modals/RoleCreateModal.vue';
import RoleUpdateModal from '@/components/modals/RoleUpdateModal.vue';
import { useBusinessProcessStore } from '@/stores/businessProcess.store';
import useModal from '@/stores/modal.store';
import { useProjectStore } from '@/stores/project.store';
import { useRoleStore } from '@/stores/role.store';
import { storeToRefs } from 'pinia';
import { onMounted } from 'vue';
import { useRoute } from 'vue-router';

const roleStore = useRoleStore();
const projectStore = useProjectStore();
const businessProcessStore = useBusinessProcessStore();

const { roleList, currentRole } = storeToRefs(roleStore);
const { project } = storeToRefs(projectStore);
const { bp } = storeToRefs(businessProcessStore);
const { activeModal, openModal, closeModal } = useModal();
const route = useRoute();

onMounted(() => {
  projectStore.getProject(route.params.projectId);
  businessProcessStore.getBP(route.params.bpId);
  roleStore.getRoleList();
});

function openUpdateModal(role) {
  currentRole.value = role;
  openModal('roleUpdateModal');
}

function openDeleteModal(role) {
  currentRole.value = role;
  openModal('roleDeleteModal');
}

function deleteRole() {
  roleStore.deleteRole(currentRole.value.id).then(() => {
    closeModal();
  });
}

</script>

<template>
  <div>
    <div class="container-fluid">
      <div class="d-flex mt-3 page-header">
        <RouterLink :to="{ name: 'bp' }" class="back-btn" />
        <h1>Роли {{ bp.name }}</h1>
      </div>
    </div>
    <div class="container-fluid mt-4">
      <div class="row">
        <div class="d-flex justify-content-end mb-4 flex-wrap projects_filter-block">
          <div class="d-flex justify-content-end flex-wrap align-items-end">
            <div @click="openModal('roleCreateModal')" class="orange-btn">
              <img src="@/assets/img/plus-ico.svg" alt="" /> Создать роль
            </div>
          </div>
        </div>

        <div class="table-responsive">
          <table class="gray-table" width="100%">
            <thead>
              <tr>
                <th>id</th>
                <th>Системное название</th>
                <th v-for="locale in project.locales" :key="locale.id">
                  Наименование на {{ locale.name }}
                </th>
                <th>Действия</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="role in roleList" :key="role.id">
                <td>{{ role.id }}</td>
                <td>{{ role.name }}</td>
                <td v-for="locale in project.locales" :key="locale.id">
                  {{ role.title[locale.id] }}
                </td>
                <td>
                  <div class="table-buttons">
                    <div class="table-button" @click.stop="openUpdateModal(role)" title="Редактирование">
                      <span class="edit-ico" />
                    </div>
                    <div class="table-button" @click.stop="openDeleteModal(role)" title="Удаление">
                      <span class="delite-ico" />
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <RoleCreateModal v-if="activeModal === 'roleCreateModal'" />
        <RoleUpdateModal v-if="activeModal === 'roleUpdateModal'" />
        <DeleteModal v-if="activeModal === 'roleDeleteModal'" :itemText="'роль'" :title="currentRole?.name"
          @confirmDelete="deleteRole()" />
      </div>
    </div>
  </div>

</template>